// description and metadata (a JSON object as text) are only sent by the generic lookups endpoint.
export type LookupResponse = {
  id: string;
  name: string | null;
  code: string | null;
  description?: string | null;
  metadata?: string | null;
};
export type PortalResponse = { id: string; name: string };
export type UserRoleResponse = { id: string; name: string };

export const PAGE_REQUEST_DEFAULT_PAGE_NUMBER = 1;
export const PAGE_REQUEST_DEFAULT_PAGE_SIZE = 25;
export const PAGE_REQUEST_MAX_PAGE_SIZE = 200;

export type PageRequest = {
  pageNumber?: number;
  pageSize?: number;
};

export function normalizePageRequest(pageRequest?: PageRequest): Required<PageRequest> {
  const pageNumber = pageRequest?.pageNumber ?? PAGE_REQUEST_DEFAULT_PAGE_NUMBER;
  const pageSize = pageRequest?.pageSize ?? PAGE_REQUEST_DEFAULT_PAGE_SIZE;

  return {
    pageNumber: pageNumber < 1 ? PAGE_REQUEST_DEFAULT_PAGE_NUMBER : pageNumber,
    pageSize:
      pageSize < 1
        ? PAGE_REQUEST_DEFAULT_PAGE_SIZE
        : Math.min(pageSize, PAGE_REQUEST_MAX_PAGE_SIZE),
  };
}

export type PagedResponse<T> = {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
};
